module.exports = __webpack_public_path__ + "static/media/the_carbon_challenge-mobile.dfff6199.jpg";